
import { ParallaxEffect, ParallaxContext } from '@/render/parallax/ParallaxEffect';
import { BaseParallaxEffect } from '@/render/parallax/BaseParallaxEffect';

export class CometTailEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const drawComet = (x: number, y: number, angle: number, size: number) => {
             ctx.save();
             ctx.translate(x, y);
             ctx.rotate(angle);
             
             // Tail
             const grad = ctx.createLinearGradient(0, 0, -size * 5, 0);
             grad.addColorStop(0, pc.color);
             grad.addColorStop(1, 'transparent');
             ctx.globalAlpha *= 0.5;
             ctx.fillStyle = grad;
             ctx.beginPath();
             ctx.moveTo(0, -size/2);
             ctx.lineTo(0, size/2);
             ctx.lineTo(-size * 5, 0);
             ctx.fill();
             
             // Head
             ctx.globalAlpha = 1;
             ctx.fillStyle = pc.color;
             ctx.beginPath();
             ctx.arc(0, 0, size/2, 0, Math.PI * 2);
             ctx.fill();
             ctx.restore();
        };

        const draw = () => {
             const count = Math.floor(3 * (config.parallaxComplexity || 1.0));
             for (let i = 0; i < count; i++) {
                 const x = ((curTime * 200 + this.pseudoRandom(i) * 5000) % (width * 4)) - width * 2;
                 const y = (this.pseudoRandom(i + 1) - 0.5) * height * 2;
                 drawComet(x, y, 0, 10 * scale / (layerIndex + 1));
             }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
